import type { RouteObject } from 'react-router';

import routes from '@/assets/constants/routes-no';
import { singleCompetitionWinnersQuery } from '@/lib/api/queries';
import { simpleRace, smartLazy } from '@/lib/router-utils';
import { queryClient } from '@/queryClient';

export const january2025Routes: RouteObject[] = [
  {
    path: routes.JANUARY_2025_COMPETITION,
    loader: () =>
      simpleRace([
        queryClient.prefetchQuery(
          singleCompetitionWinnersQuery({ slug: 'january_2025_campaign' }),
        ),
      ]),
    lazy: () => smartLazy(import('./LandingPage')),
  },
  {
    path: routes.JANUARY_2025_COMPETITION_TERMS,
    lazy: () => smartLazy(import('./Terms')),
  },
];
